// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"100":"forgot-password","710":"buyer-registration","966":"login"}[chunkId] || chunkId) + "." + {"100":"1acf69f6","268":"7cfceef3","710":"87cd787b","822":"da1add1e","966":"71465f03"}[chunkId] + ".js";
};